var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Carousel'),_c('BusinessSection'),_c('ProductSlider'),_c('SubscribeSection'),_c('Footer'),_c('BackToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }